/**
 * Plain-English role descriptions — shared by the Users screen and each user's own Profile page,
 * so the same four words (Programme admin, Editor, Reviewer, Analyst) always mean the same thing
 * wherever staff read them. Matches the matrix in apps/api/src/auth/permissions.ts exactly; if that
 * matrix changes, these must change with it.
 */
export type ProgrammeRole = "PROGRAMME_ADMIN" | "EDITOR" | "REVIEWER" | "ANALYST";

export const ROLE_LABELS: Record<ProgrammeRole, string> = {
  PROGRAMME_ADMIN: "Programme admin",
  EDITOR: "Editor",
  REVIEWER: "Reviewer",
  ANALYST: "Analyst",
};

export const ROLE_DESCRIPTIONS: Record<ProgrammeRole, string> = {
  PROGRAMME_ADMIN:
    "Configures and publishes forms, opens/closes them, exports submissions, runs review.",
  EDITOR: "Builds and edits draft forms. Cannot publish, open/close a live form, or export.",
  REVIEWER: "Reads submissions, adds review notes and scores. No export, no edit.",
  ANALYST: "Sees analytics and aggregated reports only — never individual submissions.",
};

/** Independent of programme role — whether isPii-marked fields show unmasked for this user. */
export const PII_DESCRIPTION =
  "Whether fields marked sensitive (email, phone, NIN…) show unmasked or as ade****@gmail.com-style redactions.";
